import React from 'react';
import { SvgType } from '@rocheglobal/component-library-dot-com/src/services';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { RocheButton as RocheButtonType } from '../../types/global';
import { RocheUIIcon } from '@repo/roche-ui';

type IconProps = BlokToComponentProps<
  RocheButtonType & {
    color: string;
    height: string;
    icon: SvgType;
  }
>;

export const RocheIcon = ({ blok }: IconProps): JSX.Element => {
  const { height, icon, color } = blok;

  return <RocheUIIcon height={height} icon={icon} color={color} decorative display='inline' />;
};
